import { useEffect, useState } from "react";
import { downloadPrivateObject } from "@retro-ia/shared/upload";

export interface LogoMarcaValue {
  llave?: string;
  url?: string;
  nombre?: string;
}

type Props = {
  logoMarca?: LogoMarcaValue | null;
  defaultSrc: string;
  alt: string;
  className?: string;
  onClick?: () => void;
};

/**
 * Muestra el logo de un Cliente Final. Si logoMarca tiene `llave`, obtiene
 * una URL prefirmada (S3 privado); si no, usa `logoMarca.url` (legacy).
 */
export function LogoClienteFinal({
  logoMarca,
  defaultSrc,
  alt,
  className,
  onClick,
}: Props) {
  const [resolvedUrl, setResolvedUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!logoMarca) {
      setResolvedUrl(null);
      return;
    }
    if (logoMarca.llave) {
      setLoading(true);
      downloadPrivateObject({ key: logoMarca.llave })
        .then(({ url }) => setResolvedUrl(url))
        .catch(() => setResolvedUrl(null))
        .finally(() => setLoading(false));
    } else if (logoMarca.url) {
      setResolvedUrl(logoMarca.url);
    } else {
      setResolvedUrl(null);
    }
  }, [logoMarca?.llave, logoMarca?.url]);

  const src = resolvedUrl || defaultSrc;
  if (loading && !resolvedUrl) {
    return (
      <div
        className={className}
        style={{ minHeight: 24, background: "var(--muted)" }}
        aria-label={alt}
      />
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      style={onClick ? { cursor: "pointer" } : undefined}
    />
  );
}
